import AppPageTitle from '@/components/AppPageTitle';
import AppTable from '@/components/AppTable';
import AppTableQuery from '@/components/AppTableQuery';
import PATH from '@/config/paths/PATH';
import { Button, Flex, Modal, Space, Tag, Tooltip } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import { EllipsisOutlined } from '@ant-design/icons';
import { formatPeriod, columnSorter, formatNumber } from '@/utils/formatters';
import { useMutation } from '@tanstack/react-query';
import usePrizeManagement from '@/redux/hooks/usePrizeManagement';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { getActiveBadge } from '@/utils/getActiveBadge';
import { getLuckyBox, updateLuckyBox } from '@/services/Box.service';
import AppDropdown from '@/components/AppDropdown';
import PopupViewBox from './PopupViewBox';
import ModalEditBox from './ModalEditBox';

const rowKey = 'key';

const filterOptions = [
  {
    value: null,
    label: 'All',
  },
  {
    value: '1',
    label: 'Nomal Box',
  },
  {
    value: '2',
    label: 'Monthly Box',
  },
];

function BoxManagement() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isShowPopupDetail, setIsShowPopupDetail] = useState(false);
  const [queryValues, setQueryValues] = useState({
    boxType: null,
  });
  const [isShowPopupEditBox, setIsShowPopupEditBox] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const navigate = useNavigate();

  const { data, isLoading, refetch, isRefetching } = usePaginatedQuery(
    () =>
      getLuckyBox({
        ...queryValues,
      }),
    ['prizeManagement', queryValues]
  );

  const dataTable = useMemo(() => {
    if (!data || _.isEmpty(data)) return [];

    return data.map((item, index) => {
      return {
        no: index + 1,
        ...item,
      };
    });
  }, [data]);

  const columns = [
    {
      title: 'No.',
      dataIndex: 'no',
      key: 'no',
      align: 'center',
      render: (value) => (value ? value : '-'),
      tooltip: 'ID',
    },
    {
      title: 'Award Type',
      dataIndex: 'box_type',
      key: 'box_type',
      sorter: columnSorter('box_type'),
      render: (value) => {
        if (value == null) return '-';
        return value == 1 ? 'Nomal Box' : 'Monthly Box';
      },
    },
    {
      title: (
        <Tooltip title="Số mảnh cần có (200, 500, 1000...) để mở Box">
          <span>Milestone</span>
        </Tooltip>
      ),
      dataIndex: 'milestone',
      key: 'milestone',
      render: (value) => (value ? formatNumber(value) : '-'),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type) => (type == 1 ? 'Heart' : 'Money'),
    },
    {
      title: 'Mode',
      dataIndex: 'mode',
      key: 'mode',
      sorter: columnSorter('mode'),
      render: (value) => {
        if (value === 1) {
          return <Tag color="green">Random trong khoảng min-max</Tag>;
        } else if (value === 2) {
          return <Tag color="blue">Random chọn min hoặc max</Tag>;
        } else if (value === 3) {
          return <Tag color="yellow">Chọn max</Tag>;
        }
      },
    },
    {
      title: 'Award min',
      dataIndex: 'min',
      key: 'min',
      sorter: columnSorter('min'),
      render: (value) => (value ? formatNumber(value) : '-'),
    },
    {
      title: 'Award max',
      dataIndex: 'max',
      key: 'max',
      sorter: columnSorter('max'),
      render: (value) => (value ? formatNumber(value) : '-'),
    },
    {
      title: (
        <Tooltip title="Tỉ lệ (%) ra max, dùng trong giải money">
          <span>Rate</span>
        </Tooltip>
      ),
      dataIndex: 'rate',
      key: 'rate',
      render: (value) => (value ? `${value}%` : '-'),
    },
    {
      title: (
        <Tooltip title="Số chìa khóa cần để mở hộp">
          <span>Total Key</span>
        </Tooltip>
      ),
      dataIndex: 'total_key',
      key: 'total_key',
      render: (value) => (value ? value : '-'),
    },

    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      sorter: columnSorter('description'),
      render: (value) => (value ? value : '-'),
    },
  ];

  const handleOnCreate = () => {
    navigate(PATH.PRIZE_MANAGEMENT.CREATE);
  };

  const handleRefresh = () => {
    refetch();
  };

    const updateBoxMutation = useMutation({
    mutationFn: updateLuckyBox,
  });

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Box Management" />
      {/* <AppTableQuery
        hasDatePicker={false}
        filterLabel="Box Type"
        filterOptions={filterOptions}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        hasSearch={false}
        handleQuery={handleQuery}
        handleReset={handleReset}
        allowClear={false}
      /> */}

      <AppTable
        columns={columns}
        dataSource={dataTable || []}
        rowKey={rowKey}
        loading={isLoading || isRefetching}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        hasPagination={false}
        hasRowAction
        // onCreate={handleOnCreate}
        onRefresh={handleRefresh}
        rowAction={(record) => {
          return (
            <AppDropdown
              options={[
                {
                  key: '1',
                  label: 'Edit',
                  onClick: () => {
                    setIsShowPopupEditBox(true);
                    setDataDetail(record);
                  },
                },
                {
                  key: '2',
                  label: `View`,
                  onClick: () => {
                    setIsShowPopupDetail(true);
                    setDataDetail(record);
                  },
                },
              ]}
              onChange={(item) => item.onClick()}
              placement="bottomRight"
              overlayStyle={{ minWidth: '150px' }}
            >
              <Button type="text" className="px-2">
                <EllipsisOutlined />
              </Button>
            </AppDropdown>
          );
        }}
      />
      {isShowPopupDetail && (
        <PopupViewBox dataDetail={dataDetail} setIsShowPopupDetail={setIsShowPopupDetail} />
      )}
      {
        isShowPopupEditBox && (
          <ModalEditBox initialValues={dataDetail} handleRefresh={handleRefresh} onCancel={() => setIsShowPopupEditBox(false)} />
        )
      }
    </Space>
  );
}

export default BoxManagement;
